/*
👋 “Hey” from the Praxis team
Praxis ships with support for modern browsers, but you may have users or external vendors that require IE11.
If that’s the case - you need to do two things:
- [1] change the jsxRuntime pragma value from "automatic" value to "classic". It can remain a comment, babel will read it.
      @jsxRuntime automatic
- [2] uncomment the below block between "PRAXIS IE11 START" and "PRAXIS IE11 END".
Learn more about our the default browser support in the README or at http://go/praxis-browser-support.
*/
/* PRAXIS IE11 START */
// import '@praxis/react-app-polyfill/ie11'
// import '@praxis/react-app-polyfill/stable'
// // eslint-disable-next-line no-unused-vars
// import React from 'react'
/* PRAXIS IE11 END */

import ReactDOM from 'react-dom'
import axios from 'axios'
import { onError, reportWebVitals } from '@praxis/component-logging'
import { OpenTelemetryManager } from '@measurement/opentelemetry-web'
import './styles/index.css'
import App from './App'
import tapConfig from './tapConfig'

// OpenTelemetry Initialization
tapConfig().then((config) => {
  OpenTelemetryManager.initialize({
    apiKey: config.otelApiKey, // Loaded from config.json
    serviceName: 'notifyui', // Must match your IAM/TAP application name
  })
})

// Standard errors will be automatically logged to STDOUT when thrown.
// The logging sidecar in TAP will process and send logs to the appropriate environment in Kibana.
// Learn more about TAP sidecars: https://tapdocs.prod.target.com/runtime/sidecars/#_platform_sidecars
window.onerror = onError

// Fix: @praxis/component-auth useAuthInterceptor accesses config.headers.common
// which doesn't exist in axios v1.x (headers are AxiosHeaders instances).
// Patch AxiosHeaders prototype so .common works everywhere, regardless of
// interceptor ordering.
if (axios.AxiosHeaders) {
  const proto = axios.AxiosHeaders.prototype
  if (!Object.getOwnPropertyDescriptor(proto, 'common')) {
    Object.defineProperty(proto, 'common', {
      get() {
        const self = this
        return new Proxy(
          {},
          {
            get(target, prop) {
              return self.get(String(prop))
            },
            set(target, prop, value) {
              self.set(String(prop), value)
              return true
            },
            has(target, prop) {
              return self.has(String(prop))
            },
            getOwnPropertyDescriptor(target, prop) {
              if (self.has(String(prop))) {
                return {
                  configurable: true,
                  enumerable: true,
                  value: self.get(String(prop)),
                }
              }
              return undefined
            },
          },
        )
      },
      set(value) {
        if (value && typeof value === 'object') {
          Object.entries(value).forEach(([k, v]) => this.set(k, v))
        }
      },
      configurable: true,
    })
  }
}

// If you want to start measuring performance in your app, enable the reportWebVitals()
// function below. Learn more: https://praxis.prod.target.com/components/logging#quick-start-metrics
reportWebVitals()

ReactDOM.render(<App />, document.getElementById('root'))
